import React, { useState, useEffect } from "react";
import { FaFilter, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { addToCart, getAllProducts, setShowAllNum } from "../../Redux/Actions";
import { Config } from "../../Config";
import Preloader from "../../components/Preloader/Preloader";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import ProductItem from "../../components/ProductItem/ProductItem";
import Pagination from "../../components/Pagination/Pagination";
import FilterItem from "../../components/FilterItem/FilterItem";
import NothingToShowBox from "../../components/NothingToShowBox/NothingToShowBox";
import "./Products.scss";
import "./Responsive.scss";

const Products = (props) => {
  let sliderRangerVal = { min: 0, max: 0 };
  const [filterIcon, setFilterIcon] = useState(true);
  const [sliderRangerRef, setSliderRangerRef] = useState({ min: 0, max: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPage, setMaxPage] = useState();
  const [preloader, setPreloader] = useState(true);
  const [loaderCount, setLoaderCount] = useState(true);
  const [lastCategoryId, setLastCategoryId] = useState([]);
  const [lastSearchKey, setLastSearchKey] = useState("");
  const [lastPriceMin, setLastPriceMin] = useState(0);
  const [lastPriceMax, setLastPriceMax] = useState(0);
  const [rangeLoading, setRangeLoading] = useState(false);
  const [provinces, setProvinces] = useState(null);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState(null);
  const [priceMin, setPriceMin] = useState(0);
  const [priceMax, setPriceMax] = useState(1);
  const [doForFirst, setDoForFirst] = useState(true);
  const [rangeValue, setRangeValue] = useState({ min: 0, max: 0 });
  const user = useSelector((state) => state.user);
  const products = useSelector((state) => state.products);
  const showAllNum = useSelector((state) => state.showAllNum);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  let maxPrice;
  let categoryId = [];
  let allCategoryNum;

  let searchKey = "";
  let checkForResetPage = false;
  if (props.location.state !== undefined) {
    if (props.location.state.categoryId !== null) {
      categoryId.push(props.location.state.categoryId);
      if (lastCategoryId[0] != props.location.state.categoryId) {
        checkForResetPage = true;
      }
    }
    if (props.location.state.searchKey !== null) {
      searchKey = props.location.state.searchKey;
      if (
        props.location.state.searchKey !== "" &&
        props.location.state.searchKey !== undefined &&
        lastSearchKey !== props.location.state.searchKey
      ) {
        checkForResetPage = true;
        console.log("2");
      }
    }
  }

  // if (lastPriceMin != rangeValue.min || lastPriceMax != rangeValue.max) {
  //   checkForResetPage = true;
  //   console.log("3 ");
  // }

  const getMaxPrice = async () => {
    axios
      .get(
        "/Product/GetMaxPrice",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setPriceMin(0);
        setPriceMax(result.data.data);
        if (doForFirst) {
          setRangeValue({ min: 0, max: result.data.data });
          setDoForFirst(false);
        }
        maxPrice = result.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetFilterIntialData = async (
    catergory,
    minPrice,
    maxPrice,
    currentPageId,
    key,
    orderBy,
    provinceId,
    cityId
  ) => {
    let initialData;
    if (showAllNum !== null) {
      initialData = JSON.stringify({
        ProductCategoryId: null,
        Key: key,
        // category: parseInt(localStorage.getItem("categoryNum")),
        category: showAllNum,
        MinWeight: 0,
        MaxWeight: 0,
        MinCutting: 0,
        MaxCutting: 0,
        MinNumberOfJewels: 0,
        MaxNumberOfJewels: 0,
        MinUnitPrice: minPrice,
        MaxUnitPrice: maxPrice,
        CountryIds: null,
        OrderBy: orderBy,
        PageId: currentPageId,
        PageCount: 1,
        cityId: cityId,
        provinceId: provinceId,
      });
    } else {
      initialData = JSON.stringify({
        ProductCategoryId: catergory,
        Key: key,
        MinWeight: 0,
        MaxWeight: 0,
        MinCutting: 0,
        MaxCutting: 0,
        MinNumberOfJewels: 0,
        MaxNumberOfJewels: 0,
        MinUnitPrice: minPrice,
        MaxUnitPrice: maxPrice,
        CountryIds: null,
        OrderBy: orderBy,
        PageId: currentPageId,
        PageCount: 1,
        cityId: cityId,
        provinceId: provinceId,
      });
    }
    await getMaxPage(initialData);
    await getAllProduct(initialData);
    await getMaxPrice();
    setRangeLoading(false);
  };

  useEffect(async () => {
    await getProvinces();
    // dispatch(setShowAllNum(null));
  }, []);

  const getProvinces = async () => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    // await fetch(`${Config.apiPath2}/providerApi/getProvinces`, requestOptions)
    await fetch(`${Config.apiPath}/api/provinces`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setProvinces(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  const getCityHandler = (id) => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    // fetch(`${Config.apiPath2}/providerApi/getCities?provinceId=${id}`, requestOptions)
    fetch(`${Config.apiPath}/api/Cities/GetCityWithFilter/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => setCities(result.data))
      .catch((error) => console.log("error", error));
  };

  useEffect(async () => {
    if (checkForResetPage) {
      setCurrentPage(1);
      checkForResetPage = false;
    }

    Config.pageUp();
    setLastCategoryId(categoryId);
    setLastSearchKey(searchKey);
    setLastPriceMax(rangeValue.max);
    setLastPriceMin(rangeValue.min);
    if (categoryId.length > 0) {
      GetFilterIntialData(categoryId, rangeValue.min, rangeValue.max, currentPage, searchKey, 1, province, city);
    } else {
      GetFilterIntialData(null, rangeValue.min, rangeValue.max, currentPage, searchKey, 1, province, city);
    }
  }, [
    currentPage,
    sliderRangerRef,
    // rangeValue,
    props.location.state !== undefined && props.location.state.categoryId,
    props.location.state !== undefined && props.location.state.searchKey,
    // localStorage.getItem("categoryNum"),
    showAllNum,
  ]);

  const getMaxPage = async (initialData) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    user[0]?.token && headers.append("Authorization", `Bearer ${user[0]?.token}`);
    let requestOptions = {
      method: "POST",
      headers: headers,
      body: initialData,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/Product/GetMaxPages", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setMaxPage(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  const getAllProduct = async (data) => {
    setPreloader(true);
    if (loaderCount) {
      setLoaderCount(false);
    }
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    user[0]?.token && headers.append("Authorization", `Bearer ${user[0]?.token}`);

    let requestOptions = {
      method: "POST",
      headers: headers,
      body: data,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/Product/GetCategoryProducts", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        dispatch(getAllProducts(result.data));
        if (data.ProductCategoryId !== result.data.ProductCategoryId) {
          setCurrentPage(1);
        }
        setPreloader(false);
      })
      .catch((error) => {
        // console.log(error);
        setPreloader(false);
      });
  };

  // const breadCrumbData = [
  //   { title: "خانه", link: "/" },
  //   { title: "محصولات", link: "/products" },
  // ];

  const setPageHandler = (e) => {
    setCurrentPage(Number(e.target.innerText));
  };

  const nextPageHandler = () => {
    setCurrentPage(currentPage + 1);
  };

  const prevPageHandler = () => {
    setCurrentPage(currentPage - 1);
  };

  // const addToCartHandler = (product) => {
  //   if (user.length > 0) {
  //     const productSelected = cart.find((item) => item.id === product.id);
  //     if (productSelected === undefined) {
  //       addToCartServer(user[0]?.token, product, product.id, 1);
  //     } else {
  //       axios
  //         .get(
  //           `/Product/GetProduct/${product.id}`,
  //           user[0]?.token && {
  //             headers: {
  //               Authorization: `Bearer ${user[0]?.token}`,
  //             },
  //           }
  //         )
  //         .then((result) => {
  //           if (productSelected.count >= result.data.data.count) {
  //             toast.error("درخواست شما بیشتر از موجودی است!");
  //           } else {
  //             addToCartServer(user[0]?.token, product, product.id, 1);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //     }
  //   } else {
  //     props.history.push("/login");
  //   }
  // };

  // const addToCartServer = (token, product, productId, count) => {
  //   let myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Authorization", `Bearer ${token}`);

  //   let raw = JSON.stringify({
  //     productId: productId,
  //     providerId:,
  //     isApprovedPrice:,
  //     Count: count,
  //   });

  //   let requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(Config.apiPath + "/orders/addtocart", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.status === 200) {
  //         let newProduct = Object.assign(product, { orderDetailId: result.data.orderDetailId });
  //         dispatch(addToCart(newProduct));
  //       } else {
  //         toast.error(<div>{result.messages}</div>);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  // };

  const removeFilters = async () => {
    props.history.push({
      pathname: `/products`,
      state: { categoryId: null, searchKey: "" },
    });
    let provinceSelect = document.getElementById("provinceSelect").options;
    // for (var i = 0; i < provinceSelect.length; i++) {
    provinceSelect[0].selected = true;
    // }
    let citySelect = document.getElementById("citySelect").options;
    // for (var i = 0; i < citySelect.length; i++) {
    citySelect[0].selected = true;
    // }
    await getMaxPrice();
    setPriceMin(0);
    setProvince(null);
    setCity(null);
    setPriceMax(priceMax);
    setRangeLoading(true);
    setRangeValue({ min: 0, max: priceMax });
    if (categoryId.length > 0) {
      // GetFilterIntialData(categoryId, rangeValue.min, rangeValue.max, currentPage, searchKey, 1);
      GetFilterIntialData(categoryId, 0, priceMax, currentPage, searchKey, 1, null, null);
    } else {
      // GetFilterIntialData(null, rangeValue.min, rangeValue.max, currentPage, searchKey, 1);
      GetFilterIntialData(null, 0, priceMax, currentPage, searchKey, 1, null, null);
    }
  };

  // const amountFilterHandler = () => {
  //   setSliderRangerRef(sliderRangerVal);
  //   if (lastPriceMin != sliderRangerRef.min || lastPriceMax != sliderRangerRef.max) {
  //     if (categoryId.length > 0) {
  //       GetFilterIntialData(categoryId, sliderRangerRef.min, sliderRangerRef.max, currentPage, searchKey, 1);
  //     } else {
  //       GetFilterIntialData(null, sliderRangerRef.min, sliderRangerRef.max, currentPage, searchKey, 1);
  //     }
  //   }
  // };

  const openFilterList = (e) => {
    if (e.target.parentNode.classList.contains("open")) {
      e.target.parentNode.classList.remove("open");
      e.target.parentNode.style.height = "40px";
    } else {
      e.target.parentNode.classList.add("open");
      e.target.parentNode.style.height = Number(e.target.nextElementSibling.clientHeight + 101) + "px";
    }
  };

  const openMobileProductFilter = (e) => {
    let body = document.body;
    let backdropFilter = document.querySelector(".backdropFilter");
    let mobileProductFilter = document.querySelector(".filterBox.mobile");
    if (mobileProductFilter.classList.contains("open")) {
      body.style.overflowY = "auto";
      backdropFilter.classList.remove("show");
      mobileProductFilter.classList.remove("open");
      setFilterIcon(true);
    } else {
      body.style.overflowY = "hidden";
      mobileProductFilter.classList.add("open");
      backdropFilter.classList.add("show");
      setFilterIcon(false);
    }
  };

  const closeBackdropFilter = (e) => {
    let body = document.body;
    let backdropFilter = document.querySelector(".backdropFilter");
    let mobileProductFilter = document.querySelector(".filterBox.mobile");
    if (mobileProductFilter.classList.contains("open")) {
      body.style.overflowY = "auto";
      backdropFilter.classList.remove("show");
      mobileProductFilter.classList.remove("open");
      setFilterIcon(true);
    } else {
      body.style.overflowY = "hidden";
      mobileProductFilter.classList.add("open");
      backdropFilter.classList.add("show");
      setFilterIcon(false);
    }
  };

  const amountRangeHandler = (e) => {
    setRangeValue({ min: e.min, max: e.max });
  };

  const priceFilterApplied = (e) => {
    setRangeLoading(true);
    setRangeValue({ min: e.min, max: e.max });
    setTimeout(() => {
      if (lastPriceMin != rangeValue.min || lastPriceMax != rangeValue.max) {
        if (categoryId.length > 0) {
          GetFilterIntialData(categoryId, rangeValue.min, rangeValue.max, currentPage, searchKey, 1, province, city);
        } else {
          GetFilterIntialData(null, rangeValue.min, rangeValue.max, currentPage, searchKey, 1, province, city);
        }
      }
    }, 500);
  };

  return (
    <section className="productsWrapper mobile">
      <Helmet>
        {/* <title>ایران رگالو | محصولات</title> */}
        <title>{Config.helmetTitle} | محصولات</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {/* {preloader && loaderCount && <Preloader active={preloader} />} */}
      {/* <BreadCrumb breadCrumbData={breadCrumbData} /> */}
      <div className="productContents">
        <div className="desktop">
          <div className="filterBox mobile">
            <div className="header">
              <div className="headerBox">
                <p className="title">فیلتر ها</p>
                <div className="btnFilter">
                  <button className="btnDeleteFilters" onClick={removeFilters}>
                    حذف فیلتر ها
                  </button>
                </div>
              </div>

              {/* <div className="filterLists">
                <p className="title" onClick={(e) => openFilterList(e)}>
                  دسته بندی
                </p>
                <div className="filters">
                  <form action="">
                    <div className="lists">
                      <p className="mainTitle">سرویس ها</p>
                      <div className="formGroup">
                        <label className="checkbox">
                          سرویس جواهری
                          <input type="checkbox" />
                          <span className="checkboxmark"></span>
                        </label>
                      </div>
                      <div className="formGroup">
                        <label className="checkbox">
                          سرویس زنجیری
                          <input type="checkbox" />
                          <span className="checkboxmark"></span>
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}
              {/* <div className="filterLists">
                <p className="title" onClick={(e) => openFilterList(e)}>
                  کشور ها
                </p>
                <div className="filters">
                  <form action="">
                    <div className="lists">
                      <div className="formGroup">
                        <label className="checkbox">
                          IRAN
                          <input type="checkbox" />
                          <span className="checkboxmark"></span>
                        </label>
                      </div>
                      <div className="formGroup">
                        <label className="checkbox">
                          Italy
                          <input type="checkbox" />
                          <span className="checkboxmark"></span>
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}
              {/* <div className="filterLists">
                <p className="title" onClick={(e) => openFilterList(e)}>
                  قیمت
                </p>
                <div className="filters">
                  <div className="formWrap">
                    <div className="lists">
                      <p className="mainTitle">محدوده قیمت</p>
                      <div className="loadingWrapper">
                        <span className="mPrice">
                          {Config.separate(rangeValue.max) + " ریال  - " + Config.separate(rangeValue.min) + " ریال"}
                        </span>
                        {rangeLoading && <div className="rangeLoading" />}
                      </div>
                      <InputRange
                        maxValue={priceMax}
                        minValue={priceMin}
                        draggableTrack={false}
                        step={1000}
                        formatLabel={(value) => `${Config.separate(value)} ریال`}
                        value={rangeValue}
                        onChange={(e) => amountRangeHandler(e)}
                        onChangeComplete={(e) => {
                          priceFilterApplied(e);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="filterLists">
                <p className="title" onClick={(e) => openFilterList(e)}>
                  شهر و استان
                </p>
                <div className="filters">
                  <div className="formWrap">
                    <div className="lists">
                      <p className="mainTitle">استان</p>
                      <div className="loadingWrapper">
                        <select
                          id="provinceSelect"
                          onChange={(e) => {
                            getCityHandler(e.target.value);
                            setProvince(e.target.value);
                            let citySelect = document.getElementById("citySelect").options;
                            setCity(null);
                            citySelect[0].selected = true;
                            GetFilterIntialData(
                              categoryId,
                              rangeValue.min,
                              rangeValue.max,
                              currentPage,
                              searchKey,
                              1,
                              e.target.value,
                              city
                            );
                          }}
                          className="filterSelect"
                        >
                          <option value="" disabled selected>
                            استان
                          </option>
                          {provinces ? (
                            provinces.map((item) => {
                              return (
                                <option
                                  key={item.id}
                                  value={item.nstwProvinceId}
                                  // onClick={() => {
                                  //   getCityHandler(item.id);
                                  // }}
                                >
                                  {item.name}
                                </option>
                              );
                            })
                          ) : (
                            <option disabled>لطفا صبر کنید</option>
                          )}
                        </select>
                      </div>
                      <p className="mainTitle">شهر</p>
                      <div className="loadingWrapper">
                        <select
                          id="citySelect"
                          onChange={(e) => {
                            setCity(e.target.value);
                            GetFilterIntialData(
                              categoryId,
                              rangeValue.min,
                              rangeValue.max,
                              currentPage,
                              searchKey,
                              1,
                              province,
                              e.target.value
                            );
                          }}
                          className="filterSelect"
                        >
                          <option value="" disabled selected>
                            شهر
                          </option>
                          {cities ? (
                            cities.map((item) => {
                              return (
                                <option
                                  key={item.id}
                                  value={item.id}
                                  // onClick={() => {
                                  //   setCity(item.id);
                                  // }}
                                >
                                  {item.name}
                                </option>
                              );
                            })
                          ) : (
                            <option disabled>لطفا ابتدا استان را انتخاب کنید</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="filterLists">
                <p className="title" onClick={(e) => openFilterList(e)}>
                  عیار
                </p>
                <div className="filters">
                  <form action="">
                    <div className="lists">
                      <p className="mainTitle">محدوده عیار</p>
                      <SliderRanger min={ayar.min} max={ayar.max} onChange={(e) => ayarHandler(e)} />
                    </div>
                  </form>
                </div>
              </div> */}
              {/* <div className="filterLists">
                <p className="title" onClick={(e) => openFilterList(e)}>
                  وزن
                </p>
                <div className="filters">
                  <form action="">
                    <div className="lists">
                      <p className="mainTitle">محدوده وزن</p>
                      <SliderRanger min={weight.min} max={weight.max} onChange={(e) => weightHandler(e)} />
                    </div>
                  </form>
                </div>
              </div> */}
              {/* <div className="filterLists">
                <p className="title" onClick={(e) => openFilterList(e)}>
                  تعداد نگین
                </p>
                <div className="filters">
                  <form action="">
                    <div className="lists">
                      <p className="mainTitle">محدوده تعداد نگین</p>
                      <SliderRanger min={negin.min} max={negin.max} onChange={(e) => neginHandler(e)} />
                    </div>
                  </form>
                </div>
              </div> */}
            </div>
          </div>
          <div className="productsBox">
            <div className="productTools">
              <p className="title">لیست محصولات</p>
              <p className="pageCounter">
                صفحه {currentPage} از {maxPage}
              </p>
            </div>
            <div className="productItems">
              {products.length > 0 ? (
                <ProductItem
                  productItemData={products}
                  // addToCartHandler={addToCartHandler}
                  loading={preloader && loaderCount && preloader}
                />
              ) : (
                <NothingToShowBox
                  title="کالایی برای نمایش وجود ندارد!"
                  note1="- برای جستجو از عبارت یا کلمات متداول تر استفاده نمایید"
                  note2="- برای بیشتر شدن دامنه محصولات مورد نظر از فیلتر کمتر استفاده کنید "
                />
              )}
            </div>
            {maxPage > 1 && (
              <Pagination
                currentPage={currentPage}
                maxPage={maxPage}
                setPage={setPageHandler}
                next={nextPageHandler}
                prev={prevPageHandler}
              />
            )}
          </div>
          <div
            className="mobileProductFilterButton"
            data-tooltip="فیلتر محصولات"
            data-tooltip-location="left"
            onClick={(e) => openMobileProductFilter(e)}
          >
            {filterIcon ? <FaFilter /> : <FaTimes />}
          </div>
        </div>
      </div>
      <div className="backdropFilter" onClick={(e) => closeBackdropFilter(e)}></div>
    </section>
  );
};

export default React.memo(Products);
